import { createMutation } from "react-query-kit";
import type { AxiosResponse } from "axios";

import { axiosClient, queryClient } from "@api/clients";
import { useAppointmentTable } from "@api/appointment/getAppointmentTable";
import type { IApiResponse, IAxiosFn } from "@/api/types";
import { generatePath } from "@/routes/generatePath";
import type { ID } from "@/constants";

interface IVariables {
  id: ID;
  /**
   * example: '2023-10-04 11:00'  (in UTC)
   */
  start_date: string;
  index: number;
  schedule_id: number;
}

const rescheduleAppointment: IAxiosFn<
  IVariables,
  AxiosResponse<IApiResponse<unknown>>
> = (data, signal) => {
  const { id, ...rest } = data;

  return axiosClient.put(
    generatePath(`/appointments/${id}`),
    { ...rest },
    { signal },
  );
};

export const useRescheduleAppointment = createMutation({
  mutationFn: (data: IVariables) => rescheduleAppointment(data),
  onSuccess: () => {
    queryClient.invalidateQueries(useAppointmentTable.getKey());
  },
});
